import TuataraReptile from "../../assets/png/Orchard Parking lot.jpeg";

const ServiceAndSupportBanner = () => {
  return (
    <>
      <div className="">
        <div className="relative">
          <img
            src={TuataraReptile}
            alt=""
            className="w-[-webkit-fill-available] md:max-h-[592px] sm:max-h-[392px] max-h-[292px] object-cover"
          />
          <div
            className="
        bottom-0 
        absolute 
        text-[#F2F2F2CC] 
        font-extrabold
        font-[Rockwell]

        2xl:text-[152px]
        lg:text-[104px]
        md:text-[85px] 
        sm:text-[65px] 
        text-[28px] 

        2xl:leading-[110px]
        lg:leading-[74px]
        md:leading-[60px] 
        sm:leading-[47px] 
        leading-[21px]

        flex justify-center items-center w-[-webkit-fill-available] "
          >
            BECOME A DEALER
          </div>
        </div>
      </div>

      <div className="bg-[#292929] py-[66px]" style={{ boxShadow: "0px 4px 4px 0px #00000040" }}>
        <div className="custom-container">
          <div className="flex items-center justify-between flex-wrap">
            <div>
              <div className="lg:text-[38px] md:text-[35px] sm:text-[20px] text-[#000] text-[Roboto] text-[#7ABF5B] font-bold lg:pb-[28px] md:pb-[18px] pb-[10px]">
                READY TO BECOME A TUATARA DEALER?
              </div>
              <div className="font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#F2F2F2] lg:pb-[0px] md:pb-[18px] pb-[10px]">
                Inquire today to join our network of innovative dealers.
              </div>
            </div>
            <div>
              <button
                className="rounded-lg bg-[#F2F2F2] border-[#5B792E] border-[4px] font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#5B792E]  lg:py-[22px] md:py-[18px] sm:py-[15px] py-[10px] font-bold  lg:px-[90px] md:px-[70px] sm:px-[20px] px-[20px] flex items-center"
                style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              >
                FILL OUT INQUIRY FORM
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ServiceAndSupportBanner;
